import { iTradeEnv } from '@/configurations/app-configs/iTrade.env'
import { ConfigServices } from "../../services/trading-services";
import { APP_SETTING_ACTION as appTypes } from "../../constants/app";
import { I_TRADE_ACTION as types } from '../../constants/i-trade';
import { SERVICES_RESP as servicesResp, store } from "../../configurations";
import { stockActions } from "./stock.action";
import { getIdentityTypeAction} from '../auth';
import { getInitState } from '../../helpers/global';

const initStateFunc = getInitState({
  EIFIdTypeAction: getIdentityTypeAction
})

export const ConfigActions = {
    getConfigSettingsAction,
};

const marketIndex = {
  HKEX: 1,
  MAMK: 2,
  SZMK: 3,
  USEX: 4,
  FUND: 5
}

function getConfigSettingsAction(params, callback) {
    return (dispatch, getState) => {
        ConfigServices.getConfigSettingsService(params, (res) => {
            if (res.status === servicesResp.STATUS_OK) {
                const tradeConfig = res.result.trading;
                const typeKeys = Object.keys(tradeConfig)

                dispatch({
                  type: types.GET_TRADING_CONFIG_SETTING,
                  tradeConfigSettings: tradeConfig,
                });
                dispatch({
                  type: types.GET_PASSWORD_RULE,
                  passwordRule: res.result.passwordRule,
                });

                if (typeKeys.length > 0) {
                  let marketMap = {}
                  const markets = typeKeys.reduce((prev, key) => {
                    const support = tradeConfig[key].support
                    const marketKey = Object.keys(support)
                    prev = prev.concat(marketKey)
                    marketMap = Object.assign(marketMap, support)
                    return prev
                  }, []).sort((a, b) => marketIndex[a] - marketIndex[b])

                  if (markets.length > 0) {
                    dispatch(stockActions.getGoodTillDateAction(markets[0]));
                    const marketData = markets.reduce((acc, market) => {
                      acc.push({
                          label: iTradeEnv?.actions?.trading?.market_label ? `market_${market.toLowerCase()}` : market ,
                          value: market
                      })
                      return acc;
                    }, [])
                    dispatch({
                        type: types.GET_MARKET,
                        markets: marketData
                    });
                    dispatch({
                        type: types.SET_CURRENT_MARKET,
                        currentMarket: markets[0]
                    });

                    const orderTypeList = marketMap[markets[0]].split(',');
                    const orderTypes = orderTypeList.reduce((acc, type) => {
                        acc.push({
                            label: `order_type_${type.toLowerCase()}`,
                            value: type
                        })
                        return acc;
                    }, [])

                    dispatch({
                        type: types.SET_ORDER_TYPE,
                        orderTypes
                    });
                  }

                }

                const getIdTypeAction = initStateFunc('TTLIdTypeAction')
                if(typeof getIdTypeAction === 'function'){
                  getIdTypeAction(dispatch, getState)
                }


                // if (markets.length > 0) {
                //     dispatch(stockActions.getGoodTillDateAction(markets[0]));
                //     const getIdTypeAction = initStateFunc('TTLIdTypeAction')
                //     if(typeof getIdTypeAction === 'function'){
                //       getIdTypeAction(dispatch, getState)
                //     }
                //     const marketData = markets.reduce((acc, market) => {
                //         acc.push({
                //             label: iTradeEnv?.actions?.trading?.market_label ? `market_${market.toLowerCase()}` : market ,
                //             value: market
                //         })
                //         return acc;
                //     }, [])
                //     dispatch({
                //         type: types.GET_MARKET,
                //         markets: marketData
                //     });
                //     dispatch({
                //         type: types.SET_CURRENT_MARKET,
                //         currentMarket: markets[0]
                //     });
                //     const orderTypeList = tradeConfig.stocks.support[markets[0]].split(',');
                //     const orderTypes = orderTypeList.reduce((acc, type) => {
                //         acc.push({
                //             label: `order_type_${type.toLowerCase()}`,
                //             value: type
                //         })
                //         return acc;
                //     }, [])
                //     dispatch({
                //         type: types.SET_ORDER_TYPE,
                //         orderTypes
                //     });
                // }
            } else {
                // const toast = {
                //     type: "error",
                //     autoClose: true,
                //     errorCode: res.status,
                //     isOpen: true,
                // };
                // dispatch({
                //     type: appTypes.SHOW_TOAST,
                //     toast: toast,
                // });
            }
        });
    };
}
